import React, { FC } from 'react';

import { SettingsFrame } from 'components';
import { FeatureHOC } from 'features';

import {
  PowerManagement,
  AutorunBlock,
  ClientCapabilities,
  ProductShowcase,
  LanguageClubRules,
  FastLogin,
  DownloadShell,
} from './components';

export const ShellTab: FC = () => {
  return (
    <>
      <SettingsFrame>
        <DownloadShell />
      </SettingsFrame>
      <PowerManagement />
      <AutorunBlock />
      <ClientCapabilities />
      <ProductShowcase />
      <LanguageClubRules />
      <FeatureHOC alias="fast_login">
        <FastLogin />
      </FeatureHOC>
    </>
  );
};
